<template>
  <div class="dust">
    <div class="dust-item">
      <div class="title">
        <span class="title-text">扬尘监测设备</span>
      </div>
      <div class="content">
        <div class="content-item" v-for="item in equipmentData">
          <img class="content-img" :src="item.img" />
          <span class="content-count"> {{ originDustData[item.props] }}{{ item.unit }}</span>
          <span class="content-des">{{ item.desc }}</span>
        </div>
      </div>
    </div>
    <div class="dust-item">
      <div class="title">
        <span class="title-text">扬尘监测</span>
      </div>
      <div class="content">
        <div class="content-item" v-for="item in dustData">
          <img class="content-img" :src="item.img" />
          <span class="content-count"> {{originDustData[item.props] }}{{ item.unit }}</span>
          <span class="content-des">{{ item.desc }}</span>
        </div>
      </div>
      <div class="card">
        <div class="card-tab">
          <div class="tab-item" @click="changeTab('pm25')" :class="activeTab === 'pm25' ? 'activeTab' : ''">PM2.5</div>
          <div class="tab-item" @click="changeTab('pm10')" :class="activeTab === 'pm10' ? 'activeTab' : ''">PM10</div>
          <div class="tab-item" @click="changeTab('tsp')" :class="activeTab === 'tsp' ? 'activeTab' : ''">TSP</div>
        </div>
        <div class="card-pic">
          <picView :option="dustOption"></picView>
        </div>
      </div>
    </div>
    <div class="dust-item">
      <div class="title">
        <span class="title-text">噪音检测</span>
      </div>
      <div class="card">
        <div style="height: 100%; width: 100%;padding: 16px;">
          <picView :option="noiseOption"></picView>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { getDustData,getLine } from '@/utils/indexApi'
import picView from '../common/pic.vue'
export default {
  components: { picView },
  props:{
    id:{
      type: Number,
      default(){
        return ''
      }
    }
  },
  data() {
    return {
      equipmentData: [
        { count: 32, desc: '现场温度（实时）', props: 'temperature', unit: '℃', img: require('@/assets/image/index/温度@2x.png') },
        { count: 32, desc: '现场湿度（实时）', props: 'humidity', unit: '%', img: require('@/assets/image/index/湿度@2x.png') },
        { count: 32, desc: '现场风力（实时）', props: 'windSpeed', unit: '', img: require('@/assets/image/index/风力.png') },

        { count: 32, desc: '现场风向（实时）', props: 'windDirectionStr', unit: '', img: require('@/assets/image/index/风向@2x.png') },

        { count: 32, desc: '现场噪音（实时）', props: 'noise', unit: 'db', img: require('@/assets/image/index/噪音@2x.png') },

        { count: 32, desc: '今日预警（实时）', props: 'alarmNum', unit: '', img: require('@/assets/image/index/预警.png') }

      ],
      dustData: [
        { count: 32, desc: '现场PM2.5（当前）', props: 'pm25', unit: '℃', img: require('@/assets/image/index/PM2.5@2x.png') },
        { count: 32, desc: '现场PM10（当前）', props: 'pm10', unit: '%', img: require('@/assets/image/index/PM10@2x.png') },
        { count: 32, desc: '现场TSP（当前）', props: 'tsp', unit: '', img: require('@/assets/image/index/TSP@2x.png') },

      ],
      originDustData:{},
      activeTab: 'pm25',
      dustOption: {
        title: {
          text: '单位',
          textStyle:{
            color:'#fff',
            fontSize:14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: [{
            name:'国控值',
            icon: 'circle',
            itemStyle:{
              color:'rgb(91, 241, 246)',
            }
          }, {
            name:'阈值',
            icon: 'circle',
            itemStyle:{
              color:'rgb(254, 196, 82)',
            }
          },],
          right:0,
          lineStyle:{
            opacity:0
          },
          textStyle:{
            color:'#fff'
          }
        },
        toolbox: {
        
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
            },  
            splitLine: {
              show: false,
            },
          }
        ],
        series: [
          {
            name: '国控值',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '阈值',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
         
        ]
      },
      noiseOption:{
        title: {
          text: '单位',
          textStyle:{
            color:'#fff',
            fontSize:14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: [{
            name:'国控值',
            icon: 'circle',
            itemStyle:{
              color:'rgb(91, 241, 246)',
            }
          }, {
            name:'阈值',
            icon: 'circle',
            itemStyle:{
              color:'rgb(254, 196, 82)',
            }
          },],
          right:0,
          lineStyle:{
            opacity:0
          },
          textStyle:{
            color:'#fff'
          }
        },
        toolbox: {
        
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: [],
              axisLabel: {
              interval: 'auto',
              padding: [0, 0, 0, 35],
              rotate: 0,
            },
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              show: true,
            },  
            splitLine: {
              show: false,
            },
          }
        ],
        series: [
          {
            name: '国控值',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '阈值',
            type: 'line',
            stack: 'Total',
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
         
        ]
      },
      optionData:{}
    }
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab
      this.dustOption.series[0].data =this.optionData[tab+'Standard']
      this.dustOption.series[1].data = this.optionData[tab]
    },
    getDustOption(){
    },
    getDustData(){
      getDustData(this.id).then(res=>{
        this.originDustData = res.data
      })
    },
    getLineData(){
      const startDate = new moment().subtract(1,'days').format('YYYY-MM-DD hh:mm:ss')
      const endDate = new moment().format('YYYY-MM-DD hh:mm:ss')
      // const startDate = '2024-05-19 00:00:00'
      // const endDate ='2024-05-19 23:59:59'
  
      const params={
        startDate,
        endDate
      }
      getLine(params).then(res=>{
        const data = res.data
        const date = data.map(item=>item.hour)
        const pm25 = data.map(item=>item.avg_pm25)
        const pm25Standard  = data.map(item=>item.avg_pm25_standard)
        const pm10 = data.map(item=>item.avg_pm10)
        const pm10Standard  = data.map(item=>item.avg_pm10_standard) 
        const tsp = data.map(item=>item.avg_tsp)
        const tspStandard  = data.map(item=>item.avg_tsp_standard)
        const noise = data.map(item=>item.avg_noise)
        const noiseStandard  = data.map(item=>item.avg_noise_standard)
        this.optionData = {date,pm25,pm25Standard,pm10,pm10Standard,tsp,tspStandard,noise,noiseStandard}
        this.noiseOption.xAxis[0].data = date
        this.noiseOption.series[0].data = noiseStandard
        this.noiseOption.series[1].data = noise
        this.dustOption.xAxis[0].data = date
        this.dustOption.series[0].data = pm25Standard
        this.dustOption.series[1].data = pm25
      })
    }
  },
  created(){
    this.getLineData()
    this.getDustData()
  }
}
</script>
<style scoped lang="scss">
.title {
  width: 236px;
  height: 26px;
  background: url('@/assets/image/index/二级标题-背景@2x.png');
  background-size: contain;

  .title-text {
    margin-left: 32px;
    font-family: AlibabaPuHuiTi_2_75_SemiBold;
    font-size: 18px;
    color: #D1D6DF;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    // background: linear-gradient(270deg, #ACDDFF 0%, #FFFFFF 100%);
  }
}

.dust {
  .dust-item {
    margin-bottom: 28px;
  }

  .card {
    margin-top: 16px;
    width: 410px;
    height: 294px;
    background: rgba(0, 25, 49, 0.5);
    box-shadow: inset 0px 0px 24px 0px rgba(72, 125, 163, 0.5);
    border-radius: 8px;
    border: 1px solid rgba(131, 166, 199, 0.3);
    backdrop-filter: blur(14px);

    .card-tab {
      display: flex;
      align-items: center;
      height: 40px;
      border-bottom: 1px solid rgba(131, 166, 199, 0.3);

      .tab-item {
        width: 80px;
        line-height: 40px;
        text-align: center;
        color: #fff;
      }

      .activeTab {
        background: url('@/assets/image/index/光效.png');
        background-size: contain
      }
    }

    .card-pic {
      height: calc(100% - 40px);
      padding: 16px;
    }
  }

  .content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 13px;
    margin-top: 16px;

    .content-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;
      width: 128px;
      height: 120px;
      padding: 9px 0;
      background: url('@/assets/image/index/数字／匡备份@2x.png') no-repeat;
      background-size: contain;

      .content-img {
        width: 60px;
        height: 50px;
      }

      .content-count {
        font-family: AlibabaPuHuiTi_2_85_Bold;
        font-size: 22px;
        color: #D9E7FF;
        line-height: 22px;
        text-align: right;
        font-style: normal;
        text-transform: none;
      }

      .content-des {
        font-family: AlibabaPuHuiTi_2_55_Regular;
        font-size: 12px;
        color: #D9E7FF;
        line-height: 13px;
        text-align: right;
        font-style: normal;
        text-transform: none;
      }

    }

  }
}
</style>